import { ComponentPropsWithRef, ReactNode } from "react";
import classNames from "classnames";
import "./index.module.css";
import { Typography } from "..";
import SvgIcon from "@/components/common/SvgIcon";

type TProps = Omit<ComponentPropsWithRef<"input">, "size" | "checked"> & {
  size?: "xs" | "md" | "lg";
  id: string;
  label?: ReactNode | string;
  checked?: boolean | "half";
};

const Checkbox = (props: TProps) => {
  const { label, id, className, size = "md", checked, ...rest } = props;
  return (
    <div className="flex items-center select-none" style={{ columnGap: "8px" }}>
      <div className="relative grid">
        <input
          {...rest}
          id={id}
          type={"checkbox"}
          className={classNames(
            `${className} focus-visible:outline-none cursor-pointer`,
            {
              "w-3 h-3": size === "xs",
              "w-4 h-4": size === "md",
              "w-5 h-5": size === "lg",
              "opacity-0": checked === "half",
            },
          )}
          checked={!!checked}
        />
        {checked === "half" && (
          <SvgIcon
            className={classNames(
              "!fill-gray-800 !stroke-white absolute top-0 left-0 pointer-events-none",
              {
                "w-3 h-3": size === "xs",
                "w-4 h-4": size === "md",
                "w-5 h-5": size === "lg",
              },
            )}
            iconName="checkboxControlLocal"
          />
        )}
      </div>
      {label && (
        <label className={"cursor-pointer"} htmlFor={id}>
          <Typography color="text-gray-600" variant="Body2-Regular">
            {label}
          </Typography>
        </label>
      )}
    </div>
  );
};

export default Checkbox;
